import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/murifield/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={692}
              height={443}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C92042" }}>Solution</span>
            </h2>
            <p>
              Muirfield website is a progressive real estate platform designed
              for investors who focus on opportunistic investment across all
              real estate sub-sectors, delivering flexible, creative and
              scalable solutions for high-integrity sponsors.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
